export default "__VITE_ASSET__8BYEwqEp__"